import axios from 'axios'
import { LOGOUT, EXPIRED_SESSION } from '@/vuex/types'
import { app } from '@/main'

let instance = axios.create({
  baseURL: '/api',
  timeout: 60000
})

instance.interceptors.request.use(function (config) {
  let token = window.sessionStorage.getItem('token')
  if (token) {
    config.headers.common['Authorization'] = 'Bearer ' + token
  }
  let loadingDiv = document.createElement('div')
  let spinnerDiv = document.createElement('div')
  let bounceDiv1 = document.createElement('div')
  let bounceDiv2 = document.createElement('div')
  let bounceDiv3 = document.createElement('div')
  loadingDiv.id = 'loadingDiv'
  spinnerDiv.className = 'spinner'
  loadingDiv.className = 'loading'
  bounceDiv1.className = 'bounce1'
  bounceDiv2.className = 'bounce2'
  bounceDiv3.className = 'bounce3'
  let exists = document.getElementById('loadingDiv')
  if (!exists) {
    document.body.appendChild(loadingDiv)
    loadingDiv.appendChild(spinnerDiv)
    spinnerDiv.appendChild(bounceDiv1)
    spinnerDiv.appendChild(bounceDiv2)
    spinnerDiv.appendChild(bounceDiv3)
    loadingDiv.setAttribute('data-requests', 1)
    loadingDiv.setAttribute('data-responses', 0)
  } else {
    let count = parseInt(exists.getAttribute('data-requests'))
    exists.setAttribute('data-requests', count + 1)
  }
  return config
}, function (error) {
  return Promise.reject(error.response)
})

instance.interceptors.response.use(function (response) {
  let loadingDivRemove = document.getElementById('loadingDiv')
  if (loadingDivRemove) {
    let count = parseInt(loadingDivRemove.getAttribute('data-responses'))
    loadingDivRemove.setAttribute('data-responses', count + 1)
    let requests = parseInt(loadingDivRemove.getAttribute('data-requests'))
    let responses = parseInt(loadingDivRemove.getAttribute('data-responses'))
    if (requests === responses) {
      loadingDivRemove.parentNode.removeChild(loadingDivRemove)
    }
  }
  return response
}, function (error) {
  let loadingDivRemove = document.getElementById('loadingDiv')
  if (loadingDivRemove) {
    let count = parseInt(loadingDivRemove.getAttribute('data-responses'))
    loadingDivRemove.setAttribute('data-responses', count + 1)
    let requests = parseInt(loadingDivRemove.getAttribute('data-requests'))
    let responses = parseInt(loadingDivRemove.getAttribute('data-responses'))
    if (requests === responses) {
      loadingDivRemove.parentNode.removeChild(loadingDivRemove)
    }
  }
  if (error.response && error.response.status === 401) {
    app.$store.commit(EXPIRED_SESSION, true)
    app.$store.dispatch(LOGOUT)
    let redirect = app.$router.currentRoute.path
    if (!redirect.includes('login') && !redirect.includes('register') && !redirect.includes('forgot-password') && !redirect.includes('forgot-username') &&
    !redirect.includes('emailVerification') && !redirect.includes('resendVerification') && !redirect.includes('reset-password')) {
      redirect = '/login'
      app.$router.push(redirect)
    }
    return redirect
  } else {
    return Promise.reject(error.response)
  }
})

class Api {
  async getForm (permalink, params = {}, auth = 'admin') {
    try {
      let { data } = await instance.get(`${auth}/form`, {
        params: {
          permalink,
          ...params
        }
      })
      return data.form
    } catch (err) {
      throw err
    }
  }

  async submitForm (formData, method = 'post', auth = 'admin') {
    try {
      let { data } = await instance[method](`${auth}/form`, formData)
      return data.result
    } catch (err) {
      throw err
    }
  }

  async verifyEmail (token) {
    try {
      let response = await instance.post('public/account', {token, permalink: 'verifyEmail'})
      return response
    } catch (err) {
      throw err
    }
  }

  async refreshLoggedInUser () {
    let { data } = await instance.post('admin/object/refreshLoggedInUser')
    if (!data) throw new Error('Cannot refresh user.')
    return data
  }

  async getSidebar () {
    let { data } = await instance.get('/admin/object/sidebar')
    if (!data) {
      return []
    } else {
      return data.object
    }
  }

  async loadSettings (domain) {
    let { data } = await instance.post('public/config')
    return data
  }

  async checkUsername (username) {
    let { data } = await instance.post('public/object/uniqueUsername', {
      username
    })
    return data.object
  }

  async checkReferralCode (payload) {
    let { data } = await instance.post('/admin/object/checkReferralCode', {
      payload
    })
    return data.object
  }
  async checkRepCode (payload) {
    let { data } = await instance.post('/public/object/checkRepCode', {
      payload
    })
    return data.object
  }
  async getReports (options) {
    let data
    if (options.reportType === 'invoice') {
      data = {
        dates: [],
        // This is the dummy data which is specified here, need to change later
        permalink: 'quote',
        rows: [
          {
            invoiceId: 'ABC',
            reference: 'QS3432R',
            expired: false,
            fullCost: 10000,
            approved: false,
            propertyAddress: '150 Sydney Road, Coburg',
            Customer: {
              fullName: 'Varinder'
            },
            createdAt: '2020-02-18 00:25:30.447551+00',
            uuid: '456784dfgsjk7475n'
          },
          {
            invoiceId: 'ABC',
            reference: 'QS3434R',
            expired: false,
            fullCost: 10000,
            approved: true,
            propertyAddress: '150 Sydney Road, Coburg',
            Customer: {
              fullName: 'Varinder'
            },
            createdAt: '2020-02-18 00:25:30.447551+00',
            uuid: '456784dfgsjk7475n'
          },
          {
            invoiceId: 'ABC',
            reference: 'QS3433R',
            expired: true,
            fullCost: 15000,
            approved: false,
            propertyAddress: '150 Sydney Road, Coburg',
            Customer: {
              fullName: 'John Smith'
            },
            createdAt: '2020-02-01 00:25:30.447551+00',
            uuid: '456784dfgsjk7475n'
          }
        ],
        noReslts: 'no Result default text',
        offset: 0,
        limit: 10,
        searchForm: {
          fields: []
        },
        // TODO Need to check whether plural and count variables are required or not.
        plural: 'Default value of plural',
        // NOTE This count keep track of total number of entries in the database. Although, limit and offset keep track of #quotes displayed at the time.
        count: 20
      }
    } else {
      let response = await instance.post(`admin/report/${options.reportType}`, {
        searchForm: options.searchForm,
        offset: options.offset,
        limit: options.limit,
        newSearch: options.newSearch,
        date: options.date,
        tab: options.tab,
        reportUuid: options.reportUuid,
        sortColumn: options.sortColumn,
        sortDirection: options.sortDirection
      })
      data = {
        ...response.data,
        permalink: options.reportType,
        offset: 0,
        limit: 10
      }
    }
    // let { data } = await instance.post(`admin/report/${options.reportType}`, {
    //   searchForm: options.searchForm,
    //   offset: options.offset,
    //   limit: options.limit,
    //   newSearch: options.newSearch,
    //   date: options.date,
    //   client: options.client,
    //   reportUuid: options.reportUuid
    // })
    return { ...data, offset: options.offset, limit: options.limit, permalink: options.reportType }
  }

  async getDashboard (date) {
    let { data } = await instance.post('admin/object/dashboard', { date })
    return data.object
  }

  async getUser (account) {
    let { data } = await instance.get('/admin/object/account', {
      params: { account }
    })
    return data.object
  }

  async getContractor (uuid) {
    let { data } = await instance.get('/admin/object/getContractor', {
      params: {
        uuid: uuid
      }
    })
    return data.object
  }

  async getReferralCode (uuid) {
    let { data } = await instance.get('/admin/object/getReferralCode', {
      params: {
        uuid: uuid
      }
    })
    return data.object
  }

  async hasMultipleAccounts (email) {
    let { data } = await instance.post('public/hasMultipleAccounts', { email })
    return data.result
  }

  async logout () {
    return await instance.post('public/logout')
  }

  async callDB () {
    let resp = await instance.get('public/callDB')
    return resp
  }

  async getCards (options) {
    let { data } = await instance.post(`admin/cards/${options.cards}`, {
      searchForm: options.searchForm,
      sortDirection: options.sortDirection,
      sortColumn: options.sortColumn,
      offset: options.offset,
      limit: options.limit,
      newSearch: options.newSearch,
      selectedOrganization: options.selectedOrganization
    })
    return { ...data, offset: options.offset, limit: options.limit, permalink: options.cards }
  }

  async geocode (address) {
    let { data } = await instance.get('/admin/object/geocode', {
      params: { address }
    })
    return data.object
  }

  async getStats (payload) {
    let { data } = await instance.post('/admin/object/getStats', { payload })
    return data.object
  }

  async getServicesData () {
    try {
      let { data } = await instance.get('/admin/object/getServicesData')
      return data.object
    } catch (err) {
      throw err
    }
  }

  async connectXero () {
    try {
      let { data } = await instance.get('/admin/xero/connectXero')
      return data.object
    } catch (err) {
      throw err
    }
  }

  async getQuoteCost (options) {
    let { data } = await instance.get('/admin/object/getQuoteCost', {
      params: { ...options }
    })
    return data.object
  }

  async getQuotePdfText (quoteTypeUuid) {
    let { data } = await instance.get('/admin/object/quotePdfText', {
      params: { quoteTypeUuid }
    })
    return data.object
  }

  async getQuoteTypeDetail (quoteTypeUuid) {
    let { data } = await instance.get('/admin/object/quoteTypeDetail', {
      params: { quoteTypeUuid }
    })
    return data.object
  }

  async addCreditCard (token, AccountUuid) {
    let { data } = await instance.post('admin/object/addCreditCard', {
      token, AccountUuid
    })
    return data.object
  }

  async getPendingCount (endpoint) {
    let data = await instance.get(`/admin/object/${endpoint}`)
    return data.data.object.count
  }

  async getQuote (quoteUuid) {
    let { data } = await instance.get('/admin/object/getQuote', {
      params: { quoteUuid }
    })
    return data.object
  }

  async uploadQuoteDocs (quoteUuid, docs) {
    let response = await instance.post('/admin/object/uploadQuoteDocs', {
      quoteUuid,
      docs
    })
    return response.data.object
  }

  async getOldQuote (newQuoteUuid) {
    let { data } = await instance.get('/admin/object/getOldQuote', {
      params: { newQuoteUuid }
    })
    return data.object
  }

  async getDatabaseItems (options) {
    let { data } = await instance.post(`admin/database/${options.permalink}`, {
      searchForm: options.searchForm,
      routeQuery: options.routeQuery,
      params: options.params,
      offset: options.offset,
      limit: options.limit,
      newSearch: options.newSearch,
      sortColumn: options.sortColumn,
      sortDirection: options.sortDirection
    })
    return { ...data, paging: { offset: options.offset, limit: options.limit }, permalink: options.permalink }
  }

  async getInUseReports () {
    let { data } = await instance.get('/admin/object/inUseReports')
    if (!data) {
      return []
    } else {
      return data.object
    }
  }

  async closeReport (openReportUuid) {
    let { data } = await instance.post('/admin/object/closeReport', {
      openReportUuid
    })
    return data.object
  }

  async getCompany (company) {
    let { data } = await instance.get('/admin/object/getCompany', {
      params: { company }
    })
    return data.object
  }
  async getContractorsCurrentBill (uuid) {
    let { data } = await instance.get('/admin/object/getContractorsCurrentBill', {
      params: {
        AssigneeUuid: uuid
      }
    })
    return data
  }

}
export default Api



// WEBPACK FOOTER //
// ./src/vuex/api/index.js